import { JOB_MODULE_PREFIX } from '../constants';
export const JOB_REASSIGN_JOB_TO_RESOURCE = `${JOB_MODULE_PREFIX}_REASSIGN_JOB_TO_RESOURCE`;
export const JOB_REASSIGN_JOB_TO_RESOURCE_SUCCESS = `${JOB_MODULE_PREFIX}_REASSIGN_JOB_TO_RESOURCE_SUCCESS`;
export const JOB_REASSIGN_JOB_TO_RESOURCE_FAILURE = `${JOB_MODULE_PREFIX}_REASSIGN_JOB_TO_RESOURCE_FAILURE`;
export const reassignJobToResourceAction = (assignmentPayload) => ({
    type: JOB_REASSIGN_JOB_TO_RESOURCE,
    payload: assignmentPayload
});
export const reassignJobToResourceSuccessAction = (jobUpdatedDate) => ({
    type: JOB_REASSIGN_JOB_TO_RESOURCE_SUCCESS,
    payload: { jobUpdatedDate }
});
export const reassignJobToResourceFailureAction = (failureMessage) => ({
    type: JOB_REASSIGN_JOB_TO_RESOURCE_FAILURE,
    payload: { failureMessage }
});
//# sourceMappingURL=reassignJobToResourceActions.js.map